<template>
  <div>
    <div class="form-group row mt-5 mb-4">
      <label class="col-sm-4">Mire kíván biztosítást kötni:</label>
      <div class="col-sm-8">
        <span v-if="contractFor == 1">Ingatlan és ingóság</span>
        <span v-if="contractFor == 2">Csak ingatlan</span>
        <span v-if="contractFor == 3">Csak ingóság</span>
      </div>
    </div>
    <div v-if="contractFor !== 3">
      <div class="form-group row mb-2">
        <label class="col-sm-4"
          >Milyen típusú a biztosítani kívánt ingatlan?</label
        >
        <div class="col-sm-8">{{ stringPropertyType }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Az ingatlan külterületen helyezkedik el?</label>
        <div class="col-sm-8">{{ propertyOutskirts ? "Igen" : "Nem" }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4"
          >Folytatnak-e olyan vállalkozási tevékenységet az ingatlanban, ami nem
          szellemi munkavégzés?</label
        >
        <div class="col-sm-8">{{ propertyPhysicalJob ? "Igen" : "Nem" }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Az ingatlan tulajdonjoga:</label>
        <div class="col-sm-8">{{ stringPropertyOwnType }}</div>
      </div>
      <div class="form-group row mb-5">
        <label class="col-sm-4">Az ingatlan irányítószáma:</label>
        <div class="col-sm-8">{{ propertyZip }}</div>
      </div>
      <h1>Főépület adatai</h1>
      <div class="form-group row mb-2">
        <label class="col-sm-4"
          >Mekkora az épület/ingatlan hasznos alapterülete?</label
        >
        <div class="col-sm-8">{{ insurancePropertyFloor }} m2</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4"
          >Az Ön által választott biztosítási összeg:</label
        >
        <div v-if="rebuild_building === 0" class="col-sm-8">
          {{ insurancePropertyInsurance | currency }}
        </div>
        <div v-else class="col-sm-8">Újjáépítési érték</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Az ingatlan építési éve:</label>
        <div class="col-sm-8">{{ insurancePropertyBuiltYear }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Életvitelszerűen tartozkodó lakók</label>
        <div class="col-sm-8">{{ insurancePropertyResidents }} fő</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Ingatlan falazata</label>
        <div class="col-sm-8">
          {{ stringPropertyWall(insurancePropertyWall) }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Ingatlan tetőzete</label>
        <div class="col-sm-8">
          {{ stringPropertyRoof(insurancePropertyRoof) }}
        </div>
      </div>
      <div v-if="sideBuildings.length > 0" class="mt-5">
        <h1>Melléképületek adatai</h1>
        <div v-for="(building, key) in sideBuildings" :key="key" class="mb-2">
          <h2 v-if="sideBuildings.length > 1">
            {{ key + 1 }}. melléképület adatai
          </h2>
          <div class="form-group row mb-2">
            <label class="col-sm-4">Melléképület alapterülete</label>
            <div class="col-sm-8">{{ building.floorArea }} m2</div>
          </div>
          <div class="form-group row mb-2">
            <label class="col-sm-4">Melléképület falazata</label>
            <div class="col-sm-8">
              {{ stringPropertyWall(building.wallType) }}
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4">Melléképület tetőzete</label>
            <div class="col-sm-8">
              {{ stringPropertyRoof(building.roofType) }}
            </div>
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <label class="col-sm-4">Választott biztosítási összeg</label>
          <div v-if="rebuild_building === 0" class="col-sm-8">
            {{ sideBuildingsInsurance | currency }}
          </div>
          <div v-else class="col-sm-8">Újjáépítési érték</div>
        </div>
      </div>
    </div>
    <div v-if="contractFor !== 2" class="mt-5">
      <h1>Ingóságok</h1>
      <div class="form-group row mb-2" v-if="acceptCalculatedInsurance">
        <label class="col-sm-4">Ajánlott biztosított ingóság ár</label>
        <div v-if="rebuild_ingosag === 0" class="col-sm-8">
          {{ calculatedInsurancePrice | currency }}
        </div>
        <div v-else class="col-sm-8">Újrabeszerzési érték</div>
      </div>
      <div class="form-group row mb-2" v-if="!acceptCalculatedInsurance">
        <label class="col-sm-4">Megadott biztosított ingóság ár</label>
        <div class="col-sm-8">{{ allGoodsPrice | currency }}</div>
      </div>
    </div>
    <h1 class="mt-5">Egyéb</h1>
    <div class="form-group row mb-2">
      <label class="col-sm-4">A szerződő magánszemély?</label>
      <div class="col-sm-8">{{ privatePerson ? "Igen" : "Nem" }}</div>
    </div>
    <div class="form-group row mb-2" v-if="!privatePerson">
      <label class="col-sm-4">Szerződő adószáma</label>
      <div class="col-sm-8">{{ contractorVat }}</div>
    </div>
    <h1 class="mt-5">Kiegészítők</h1>
    <div class="mb-4" v-if="chosenAccessories.length <= 0">
      Ön nem választott ki egyetlen kiegészítőt sem.
    </div>
    <div class="row p-3 mb-4" v-else>
      <div class="col-12 mb-3" v-for="acc in chosenAccessories" :key="acc">
        <BaseAccessory :aKey="acc" :selectable="false" />
      </div>
    </div>
    <h1>Díjfizetés és kedvezmények</h1>
    <div class="form-group row mb-2">
      <label class="col-sm-4">A biztosítás éves alapdíja:</label>
      <div class="col-sm-8">
        {{ $store.state.chooseableAccesories.accessorySumPrice | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">A kiegészítők díja összesen:</label>
      <div class="col-sm-8">{{ $store.state.eves_dij_plus | currency }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">A biztosítás éves díja összesen:</label>
      <div class="col-sm-8">
        {{ $store.state.kieg_emelt_eves_dij | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4"
        >Az Ön által választott díjfizetési gyakoriság szerinti díj:</label
      >
      <div class="col-sm-8">{{ paymentFrequentString }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Díjfizetés módja</label>
      <div class="col-sm-8">{{ stringPaymentType }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Díjfizetés gyakorisága</label>
      <div class="col-sm-8">{{ stringPaymentFrequency }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Elektronikus kommunikáció</label>
      <div class="col-sm-8">{{ electronicContact ? "Igen" : "Nem" }}</div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4">Elektronikus kárrendezés</label>
      <div class="col-sm-8">{{ electronicInsuring ? "Igen" : "Nem" }}</div>
    </div>
    <h1 class="mt-5">Személyes adatok</h1>
    <div class="form-group row">
      <label class="col-sm-4">Kockázatviselés kezdete:</label>
      <div class="col-sm-8">
        {{ new Date(riskStartDate).toLocaleDateString("hu-HU") }}
      </div>
    </div>
    <h2 class="mt-4">Kockázatviselés helye</h2>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Irányítószám:</label>
      <div class="col-sm-8">{{ propertyZip }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Település neve:</label>
      <div
        class="col-sm-8"
        v-if="typeof propertyName === 'object' && propertyName.length > 0"
      >
        {{ selectedPropertyName }}
      </div>
      <div class="col-sm-8" v-else>{{ propertyName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Közterület neve:</label>
      <div class="col-sm-8">{{ riskLocationName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Közterület jellege:</label>
      <div class="col-sm-8">{{ riskLocationType }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Házszám:</label>
      <div class="col-sm-8">{{ riskLocationHouseNumber }}</div>
    </div>
    <div class="form-group row mb-2mb-2" v-if="riskLocationBuilding !== ''">
      <label class="col-sm-4">Épület, lépcsőház, emelet, ajtó:</label>
      <div class="col-sm-8">{{ riskLocationBuilding }}</div>
    </div>
    <div class="form-group row" v-if="riskLocationTopography !== ''">
      <label class="col-sm-4">Helyrajzi szám:</label>
      <div class="col-sm-8">{{ riskLocationTopography }}</div>
    </div>
    <h2 class="mt-4">Szerződő adatai</h2>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő vezetékneve:</label>
      <div class="col-sm-8">{{ contractLastName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő keresztneve:</label>
      <div class="col-sm-8">{{ contractFirstName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő születéskori neve:</label>
      <div class="col-sm-8">{{ contractBornName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő anyja leánykori neve:</label>
      <div class="col-sm-8">{{ contractMotherChildName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő születési helye:</label>
      <div class="col-sm-8">{{ contractBornCity }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő születési dátuma:</label>
      <div class="col-sm-8">
        {{ new Date(contractBornDate).toLocaleDateString("hu-HU") }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő email címe:</label>
      <div class="col-sm-8">{{ contractEmail }}</div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4">Szerződő telefonszáma:</label>
      <div class="col-sm-8">
        +36 {{ contractPhoneNumberArea }} {{ contractPhoneNumber }}
      </div>
    </div>
    <div v-if="!contractPostAddressIsTheSame">
      <h2 class="mt-4">Levelezési cím</h2>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Irányítószám:</label>
        <div class="col-sm-8">{{ contractLocationZip }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Település neve:</label>
        <div
          class="col-sm-8"
          v-if="
            typeof contractLocationCity === 'object' &&
              contractLocationCity &&
              contractLocationCity.length > 0
          "
        >
          {{ contractSelectedLocationName }}
        </div>
        <div class="col-sm-8" v-else>{{ contractLocationCity }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület neve:</label>
        <div class="col-sm-8">{{ contractLocationName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület jellege:</label>
        <div class="col-sm-8">{{ contractLocationType }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Házszám:</label>
        <div class="col-sm-8">{{ contractLocationHouseNumber }}</div>
      </div>
      <div class="form-group row mb-2" v-if="contractLocationBuilding !== ''">
        <label class="col-sm-4">Épület, lépcsőház, emelet, ajtó:</label>
        <div class="col-sm-8">{{ contractLocationBuilding }}</div>
      </div>
      <div class="form-group row" v-if="contractLocationTopography !== ''">
        <label class="col-sm-4">Helyrajzi szám:</label>
        <div class="col-sm-8">{{ contractLocationTopography }}</div>
      </div>
    </div>
    <h2 class="mt-4">Biztosított adatai</h2>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított vezetékneve:</label>
      <div class="col-sm-8">
        {{ contractedIsInsured ? contractLastName : insuredLastName }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított keresztneve:</label>
      <div class="col-sm-8">
        {{ contractedIsInsured ? contractFirstName : insuredFirstName }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított születéskori neve:</label>
      <div class="col-sm-8">
        {{ contractedIsInsured ? contractBornName : insuredBornName }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított anyja leánykori neve:</label>
      <div class="col-sm-8">
        {{
          contractedIsInsured ? contractMotherChildName : insuredMotherChildName
        }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított születési helye:</label>
      <div class="col-sm-8">
        {{ contractedIsInsured ? contractBornCity : insuredBornCity }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított születési dátuma:</label>
      <div class="col-sm-8">
        {{
          new Date(
            contractedIsInsured ? contractBornDate : insuredBornDate,
          ).toLocaleDateString("hu-HU")
        }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított email címe:</label>
      <div class="col-sm-8">
        {{ contractedIsInsured ? contractEmail : insuredEmail }}
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4">Biztosított telefonszáma:</label>
      <div class="col-sm-8">
        +36
        {{
          contractedIsInsured ? contractPhoneNumberArea : insuredPhoneNumberArea
        }}
        {{ contractedIsInsured ? contractPhoneNumber : insuredPhoneNumber }}
      </div>
    </div>
    <div v-if="propertyIsMortgaged" class="mt-4">
      <h1>Jelzálog</h1>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitelező cég neve:</label>
        <div class="col-sm-8">{{ mortgageCreditor }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitelező cég székhelye:</label>
        <div class="col-sm-8">{{ mortgageCreditorLocation || "-" }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitelszerződés azonosítója:</label>
        <div class="col-sm-8">{{ mortgageId }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitel összege és devizaneme:</label>
        <div class="col-sm-8">{{ mortgagePrice }} {{ mortgageCurrency }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitel kezdete:</label>
        <div class="col-sm-8">
          {{ mortgageStartDate ? mortgageStartDate : "-" }}
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4">Hitel lejárata:</label>
        <div class="col-sm-8">
          {{ mortgageEndDate ? mortgageEndDate : "-" }}
        </div>
      </div>
      <h1 class="mt-4">További jelzálogok</h1>
      <div v-for="(mortgage, key) in mortgageList" :key="key">
        <h2 class="mt-4">{{ key + 2 }}. jelzálog</h2>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Hitelező cég neve:</label>
          <div class="col-sm-8">{{ mortgage.creditor }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Hitelező cég székhelye:</label>
          <div class="col-sm-8">{{ mortgage.creditorLocation || "-" }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Hitelszerződés azonosítója:</label>
          <div class="col-sm-8">{{ mortgage.mortgageId }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Hitel összege és devizaneme:</label>
          <div class="col-sm-8">
            {{ mortgage.mortgagePrice }} {{ mortgage.mortgageCurrency }}
          </div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Hitel kezdete:</label>
          <div class="col-sm-8">
            {{ mortgage.mortgageStartDate ? mortgage.mortgageStartDate : "-" }}
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4">Hitel lejárata:</label>
          <div class="col-sm-8">
            {{ mortgage.mortgageEndDate ? mortgage.mortgageEndDate : "-" }}
          </div>
        </div>
      </div>
    </div>
    <h1 class="h2 mt-4" v-if="!$store.state.dm">E-mail megerősítés</h1>
    <div class="form-group row mb-2" v-if="!$store.state.dm">
      <label class="col-sm-4" for="email_validation_code"
        >E-mailben kapott kód: <span class="text-danger">*</span></label
      >
      <ValidationProvider
        rules="required|email_verify_code"
        v-slot="{ errors, classes }"
        class="col-sm-4"
      >
        <input
          type="number"
          class="form-control"
          id="email_validation_code"
          name="email_validation_code"
          v-model="emailVerifyToken"
          :disabled="emailVerified"
          :class="{ 'is-valid': emailVerified, classes, 'dark-border': true }"
        />
        <small
          id="email_validation_code-error"
          class="text-danger input-alert"
          >{{ errors[0] }}</small
        >
      </ValidationProvider>
    </div>
    <!-- <div class="form-group row mb-2" v-if="merchant_id && !$store.state.dm"> -->
    <div class="form-group row mb-2" v-if="ertekesito_koti && !dm">
      <label class="col-sm-4" for="merchant_email"
        >Biztosításközvetítő e-mail címe:</label
      >
      <ValidationProvider
        rules="email"
        v-slot="{ errors, classes }"
        class="col-sm-4"
      >
        <input
          type="email"
          class="form-control"
          id="merchant_email"
          name="merchant_email"
          v-model="merchantEmail"
          :class="classes"
        />
        <small id="merchant_email-error" class="text-danger input-alert">{{
          errors[0]
        }}</small>
      </ValidationProvider>
    </div>
    <div class="text-danger" v-if="!$store.state.dm">
      Az e-mail cím megerősítése után az e-mail cím módosítása a későbbiekben
      már nem lehetséges.
    </div>
    <h1 class="h2 mt-4">Nyilatkozatok</h1>
    <div class="form-group">
      <div class="form-check mb-4">
        <ValidationProvider
          name="biztositasi_feltetelek"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositasi_feltetelek"
            name="nyilatkozatok[]"
            value="biztositasi_feltetelek"
            v-model="electronicCommunation"
          />
        </ValidationProvider>
        <label for="biztositasi_feltetelek" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Biztosítási szabályzat és Biztosítási termékismertető elfogadása
            <!-- <button
              :aria-label="insuranceTermsOpened ? 'Bezárás' : 'Lenyitás'"
              type="button"
              :class="insuranceTermsOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceTermsClick"
            ></button> -->
            <button
              aria-label="nyilatkozat-text-expand"
              @click="insuranceTermsClick"
              type="button"
              :class="insuranceTermsOpened ? 'arrow-up' : 'arrow-down'"
            >
              <img
                v-if="insuranceTermsOpened"
                src="../assets/arrow-up-square-fill.svg"
                alt="Bootstrap"
                width="32"
                height="32"
                name="arrow_up"
              />
              <img
                v-else
                src="../assets/arrow-down-square-fill.svg"
                alt="Bootstrap"
                width="32"
                height="32"
                name="arrow_down"
              />
            </button> </b
          ><br />
          <div v-show="insuranceTermsOpened">
            Kijelentem, hogy megismertem és elfogadom a Colonnade Édes Otthon
            Lakásbiztosítás Biztosítási Feltételeit és Ügyféltájékoztatóját,
            illetve a Biztosítási termékismertetőjét.
            <iframe
              class="w-100 mt-2 docs-container"
              style="height: 500px;"
              src="https://www.colonnade.hu/media/colonnade-edes-otthon-lakasbiztositas-biztositasi-feltetelek-es-ugyfeltajekoztato"
              frameborder="1"
              title="Colonnade Édes Otthon Lakásbiztosítás BIZTOSÍTÁSI FELTÉTELEK ÉS ÜGYFÉLTÁJÉKOZTATÓ"
            ></iframe>
            <iframe
              class="w-100 mt-2 docs-container"
              style="height: 500px;"
              src="https://www.colonnade.hu/media/colonnade-edes-otthon-lakasbiztositas-biztositasi-termekismerteto-ipid"
              frameborder="1"
              title="Colonnade Édes Otthon Lakásbiztosítás Biztosítási termékismertető"
            ></iframe>
          </div>
        </label>
      </div>
      <div v-if="rbnb === 1" class="form-check mb-4">
        <ValidationProvider
          name="rbnb"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="rbnb"
            name="nyilatkozatok[]"
            value="rbnb"
            v-model="rbnbStatement"
          />
        </ValidationProvider>
        <label for="biztositasi_feltetelek" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Rövidtábú bérbadási záradék
            <button
              aria-label="nyilatkozat-text-expand"
              @click="rbnbTermsClick"
              type="button"
              :class="rbnbTermsOpened ? 'arrow-up' : 'arrow-down'"
            >
              <img
                v-if="rbnbTermsOpened"
                src="../assets/arrow-up-square-fill.svg"
                alt="Bootstrap"
                width="32"
                height="32"
                name="arrow_up"
              />
              <img
                v-else
                src="../assets/arrow-down-square-fill.svg"
                alt="Bootstrap"
                width="32"
                height="32"
                name="arrow_down"
              />
            </button> </b
          ><br />
          <div v-show="rbnbTermsOpened">
            Kijelentem, hogy megismertem és elfogadom a Colonnade Édes Otthon
            Lakásbiztosítás Szabályzat EgySzálSzo Kiegészítő lakásbiztosítási
            záradékot.
            <iframe
              class="w-100 mt-2 docs-container"
              style="height: 500px;"
              src="https://www.colonnade.hu/media/rovidtavu-berbeadas-zaradek"
              frameborder="1"
              title="Colonnade Édes Otthon Lakásbiztosítás Rövidtávú bérbeadási záradék"
            ></iframe>
          </div>
        </label>
      </div>
      <div class="form-check mb-4">
        <input
          type="checkbox"
          class="form-check-input"
          id="hirlevel"
          name="nyilatkozatok[]"
          value="hirlevel"
          v-model="marketingMails"
        />
        <label for="hirlevel" class="form-check-label">
          <b>Szeretnék értesülni az aktuális ajánlatokról, akciókról</b><br />
          Kijelentem, hogy önkéntesen hozzájárulok ahhoz, hogy a Colonnade
          Insurance S.A. Magyarországi Fióktelepe a megadott személyes adataimat
          (név, telefonszám, e-mail cím) közvetlen üzletszerzés céljából kezelje
          és azokon megkeressen. Hozzájárulásomat bármikor, korlátozás és
          indoklás nélkül, ingyenesen visszavonhatom az info@colonnade.hu címre
          küldött emailben.
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="adatvedelmi_nyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="adatvedelmi_nyilatkozat"
            name="nyilatkozatok[]"
            value="adatvedelmi_nyilatkozat"
            v-model="privacyStatement"
          />
        </ValidationProvider>
        <label for="adatvedelmi_nyilatkozat" class="form-check-label">
          <span class="text-danger">*</span>&nbsp; Tudomásul veszem, hogy a
          Colonnade Insurance S.A. Magyarországi Fióktelepe (székhely: 1134
          Budapest, Váci út 23-27.) adatkezelő által a
          <a href="https://colonnade.nopa.hu" target="_blank"
            >https://colonnade.nopa.hu</a
          >
          felhasználói adatbázisában tárolt személyes adataim átadásra kerülnek
          az OTP Mobil Kft., mint adatfeldolgozó részére. Amennyiben más
          személyek személyes adatait adtam meg (vagy fogom megadni) a
          Biztosítónak, kijelentem, hogy az érintett személyeket tájékoztattam
          az adatvédelmi szabályzat tartalmáról, illetve ezen rendelkezéseknek
          megfelelően fel vagyok hatalmazva az érintett személyek személyes
          adatainak továbbítására a Biztosító részére. A Biztosító adatvédelmi
          szabályzata közvetlenül
          <a
            href="https://www.colonnade.hu/media/adatkezelesi-tajekoztato.pdf"
            target="_blank"
            >itt</a
          >
          elérhető.
        </label>
      </div>
      <div v-if="contractReason === 'atkotes'" class="form-check mb-4">
        <ValidationProvider
          name="atkonyveles_nyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="atkonyveles_nyilatkozat"
            name="nyilatkozatok[]"
            value="atkonyveles_nyilatkozat"
            v-model="contrctReasonStatement"
          />
        </ValidationProvider>
        <label for="atkonyveles_nyilatkozat" class="form-check-label">
          <span class="text-danger">*</span>&nbsp; Hozzájárulok ahhoz, hogy a
          jelenlegi lakásbiztosítási szerződésemről túlfizetés esetén a
          díjtöbbletet az új szerződésre a Biztosító átkönyvelje, továbbá
          vállalom, hogy díjtartozás esetén a be nem fizetett díjat rendezem.
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="tudomasul_veszem"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="tudomasul_veszem"
            name="nyilatkozatok[]"
            value="tudomasul_veszem"
            v-model="acceptTerms"
          />
        </ValidationProvider>
        <label for="tudomasul_veszem" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Biztosításkötéssel kapcsolatos nyilatkozat
            <!-- <button
              :aria-label="insuranceBondStatementOpened ? 'Bezárás' : 'Lenyitás'"
              type="button"
              :class="insuranceBondStatementOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceBondStatementClick"
            ></button> -->
            <button
              aria-label="nyilatkozat-text-expand"
              @click="insuranceBondStatementClick"
              type="button"
              :class="insuranceBondStatementOpened ? 'arrow-up' : 'arrow-down'"
            >
              <img
                v-if="insuranceBondStatementOpened"
                src="../assets/arrow-up-square-fill.svg"
                alt="Bootstrap"
                width="32"
                height="32"
                name="arrow_up"
              />
              <img
                v-else
                src="../assets/arrow-down-square-fill.svg"
                alt="Bootstrap"
                width="32"
                height="32"
                name="arrow_down"
              />
            </button>
          </b>
          <ul v-show="insuranceBondStatementOpened">
            <b>Tudomásul veszem, hogy:</b>
            <li>
              jelen ajánlat a Biztosító kockázat elbírálásának alapja;
            </li>
            <li>
              a Biztosítónak az ajánlattételtől számítva 15 nap áll
              rendelkezésére az ajánlat elbírálására;
            </li>
            <li>
              a Biztosító a kockázatelbírálás eredményeként az ajánlatot
              indoklás nélkül visszautasíthatja, ebben az esetben a biztosítási
              szerződés nem jön létre;
            </li>
            <li>
              ha a biztosítási esemény a kockázatelbírálási idő alatt
              bekövetkezik, a Biztosító az ajánlatot csak abban az esetben
              utasíthatja vissza, ha az igényelt biztosítási fedezet jellege
              vagy a kockázatviselés körülményei alapján nyilvánvaló, hogy az
              ajánlat elfogadásához a kockázat egyedi elbírálása szükséges;
            </li>
            <li>
              az ajánlattételkor befizetett összeget a Biztosító díjelőlegként
              kezeli, az ajánlat elfogadása esetén pedig díjfizetésnek tekinti,
              amennyiben a Biztosító az ajánlatot elutasítja, a Biztosító a
              biztosítási díjat a szerződőnek kamatmentesen visszautalja;
            </li>
            <li>
              bármely szóbeli közlés vagy kikötés akkor érvényes, ha azokat a
              Biztosító írásban megerősítette;
            </li>
            <li>
              a szerződés létrejöttéről szóló értesítés kézhezvételétől
              számított 14 napon belül indoklás nélkül felmondhatom a
              biztosítási szerződést;
            </li>
            <li>
              a Biztosító a Colonnade Édes Otthon Lakásbiztosítás termékkel
              kapcsolatosan nem nyújt tanácsadást, a termék értékesítése pedig
              közvetlenül a biztosító online értékesítési felületén keresztül
              történik, az értékesítési folyamatban biztosításközvetítő nem
              működik közre.
            </li>
          </ul>
        </label>
      </div>
      <div class="form-check mb-4" v-if="ertekesito_koti">
        <ValidationProvider
          name="biztositaskozvetito"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositaskozvetito"
            name="nyilatkozatok[]"
            value="biztositaskozvetito"
            v-model="validMerchant"
          />
        </ValidationProvider>
        <label for="biztositaskozvetito" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Amennyiben a biztosítási szerződést független biztosításközvetítő
            értékesíti, a biztosításközvetítő kijelenti, hogy az ügyletre
            megfelelő alkuszi megbízással rendelkezik.</b
          >
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="valos_adatok"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="valos_adatok"
            name="nyilatkozatok[]"
            value="valos_adatok"
            v-model="validDatas"
          />
        </ValidationProvider>
        <label for="valos_adatok" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Nyilatkozat a szokásostól eltérő szerződési gyakorlat és a Ptk.-tól
            való eltérés elfogadásáról
            <!-- <button
              :aria-label="contractPracticeStatementClick ? 'Bezárás' : 'Lenyitás'"
              type="button"
              :class="contractPracticeStatementOpened ? 'arrow-up' : 'arrow-down'"
              @click="contractPracticeStatementClick"
            ></button> -->
            <button
              aria-label="nyilatkozat-text-expand"
              @click="contractPracticeStatementClick"
              type="button"
              :class="
                contractPracticeStatementOpened ? 'arrow-up' : 'arrow-down'
              "
            >
              <img
                v-if="contractPracticeStatementOpened"
                src="../assets/arrow-up-square-fill.svg"
                alt="Bootstrap"
                width="32"
                height="32"
                name="arrow_up"
              />
              <img
                v-else
                src="../assets/arrow-down-square-fill.svg"
                alt="Bootstrap"
                width="32"
                height="32"
                name="arrow_down"
              />
            </button>
          </b>
          <ul class="hyphens" v-show="contractPracticeStatementOpened">
            <b>Kijelentem, hogy:</b
            ><br />
            tájékoztatást kaptam arra vonatkozóan, hogy a Colonnade Édes Otthon
            Lakásbiztosítás feltételeinek alábbi rendelkezései lényegesen
            eltérnek a Polgári Törvénykönyvről szóló 2013. évi V. törvény (Ptk.)
            vonatkozó rendelkezéseitől:
            <li>
              A Ptk. 6:466.§ (1) bekezdésétől eltérően a Szerződő jogosult arra,
              hogy a határozatlan vagy a maximum 1 éves határozott tartamra
              kötött szerződések esetében - a biztosítási évfordulón túl –
              minden év márciusában – március 31-ig a Biztosítóhoz beérkezően –
              költségmentesen élhessen egy további felmondási lehetőséggel az
              adott év április 30. napjára vonatkozóan, egyebekben a rendes
              felmondás szabályai alapján felmondja a szerződést. Az (1)
              bekezdés szerinti felmondási lehetőségről a biztosító a szerződő
              felet minden év február 15. napjáig tájékoztatja.
            </li>
            <li>
              A Ptk. 6:22.§ (1) bekezdésében foglalt 5 éves elévülési időtől
              eltérően a biztosítási szerződésből eredő igények kettő év alatt
              évülnek el.
            </li>
            <li>
              A Ptk. 6:466.§ (1) bekezdéstől eltérően, amennyiben a biztosító és
              a külső szolgáltató közötti szerződés, valamely okból megszűnik, a
              biztosítónak joga van az Assistance kiegészítő biztosítást az
              általános felmondási szabályoktól eltérő módon, szükség szerint
              időarányos díjvisszatérítés mellett, a külső szolgáltatóval
              fennállt szerződés megszűnésének időpontjára felmondani.
            </li>
            <li>
              A Ptk. 6:470 § (2) bekezdésétől eltérően a biztosító az eljárási
              költségeket nem előlegezi meg.
            </li>
            <li>
              A Ptk. 6:470.§ (3) bekezdésétől eltérően a biztosító a biztosítási
              összeg keretein belül téríti meg a kamatokat és az eljárási
              költségeket.
            </li>
            <li>
              A Ptk. 6:470.§ (3) bekezdésétől eltérően a biztosító a
              szerződésben megállapított limiten belül, a Szolgáltatási táblában
              (IV. Záradékok és függelékek) meghatározott limit erejéig téríti
              meg a biztosított képviseletét ellátó jogi képviselő – máshonnan
              meg nem térülő – igazolt munkadíját és készkiadásait, illetve a
              jogi védekezés egyéb költségeit. E biztosítási fedezet annyiban
              áll fenn az észszerű, indokolt és gazdaságos költségek
              tekintetében, amennyiben azok a biztosítási szerződés fedezete alá
              tartozó, kizáró rendelkezés hatálya alá nem eső és a biztosító
              részére szerződésszerűen bejelentett biztosítási eseménnyel
              összefüggésben merültek fel. A biztosító nem téríti meg ezeket a
              költségeket, ha a szerződő/biztosított maga látja el a jogi
              védelmét.
            </li>

            Kijelentem, hogy a Colonnade Édes Otthon Lakásbiztosítás a szokásos
            szerződési gyakorlattól eltérő rendelkezéseit elfogadom, azokat
            magamra nézve kötelezőnek ismerem el.
          </ul>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import Accesory from "./components/Accesory";
import { parse as parseMoney } from "vue-currency-input";
import BaseAccessory from "./components/BaseAccessory.vue";

export default {
  components: {
    BaseAccessory,
  },
  data() {
    return {
      insuranceTermsOpened: true,
      rbnbTermsOpened: true,
      insuranceBondStatementOpened: false,
      contractPracticeStatementOpened: false,
    };
  },
  computed: {
    ...mapFields([
      "merchant_id",
      "statementSettings.privacyStatement",
      "statementSettings.insuranceTerms",
      "statementSettings.electronicCommunation",
      "statementSettings.marketingMails",
      "statementSettings.acceptTerms",
      "statementSettings.validMerchant",
      "statementSettings.validDatas",
      "statementSettings.contrctReasonStatement",
      "generalInfo.privatePerson",
      "generalInfo.contractorVat",
      "generalInfo.propertyZip",
      "generalInfo.propertyName",
      "generalInfo.rbnb",
      "generalInfo.selectedPropertyName",
      "contractSettings.emailVerified",
      "contractSettings.emailVerifyToken",
      "contractSettings.merchantEmail",
      "valaszthatoKiegeszitok",
      "chosenPackage",
      "generalInfo.rebuild_building",
      "generalInfo.rebuild_ingosag",
    ]),
    ...mapFields({
      rbnbStatement: "statementSettings.rbnb",
      contractFor: "generalInfo.contractFor",
      propertyType: "generalInfo.propertyType",
      propertyOutskirts: "generalInfo.propertyOutskirts",
      propertyPhysicalJob: "generalInfo.propertyPhysicalJob",
      propertyOwnRight: "generalInfo.propertyOwnRight",
      insurancePropertyFloor: "insuranceProperty.floorArea",
      insurancePropertyInsurance: "insuranceProperty.chosenInsurancePrice",
      insurancePropertyBuiltYear: "insuranceProperty.builtYear",
      insurancePropertyResidents: "insuranceProperty.residents",
      insurancePropertyWall: "insuranceProperty.wallType",
      insurancePropertyRoof: "insuranceProperty.roofType",
      sideBuildings: "insuranceSideBuildings.list",
      sideBuildingsInsurance: "insuranceSideBuildings.chosenInsurancePrice",

      acceptCalculatedInsurance:
        "insurancePersonalGoods.acceptCalculatedInsurance",
      calculatedInsurancePrice:
        "insurancePersonalGoods.calculatedInsurancePrice",
      allGoodsPrice: "insurancePersonalGoods.allGoodsPrice",

      paymentOptionsType: "paymentOptions.type",
      paymentOptionsFrequency: "paymentOptions.frequency",
      electronicContact: "electronicContact",
      electronicInsuring: "electronicInsuring",

      riskStartDate: "riskSettings.startDate",
      riskLocationName: "riskSettings.locationName",
      riskLocationType: "riskSettings.locationType",
      riskLocationHouseNumber: "riskSettings.locationHouseNumber",
      riskLocationBuilding: "riskSettings.locationBuilding",
      riskLocationTopography: "riskSettings.locationTopography",

      contractLastName: "contractSettings.lastName",
      contractFirstName: "contractSettings.firstName",
      contractMotherChildName: "contractSettings.motherChildName",
      contractBornName: "contractSettings.bornName",
      contractBornCity: "contractSettings.bornCity",
      contractBornDate: "contractSettings.bornDate",
      contractEmail: "contractSettings.email",
      contractPhoneNumberArea: "contractSettings.phoneNumberArea",
      contractPhoneNumber: "contractSettings.phoneNumber",
      contractPostAddressIsTheSame: "contractSettings.postAddressIsTheSame",

      contractLocationZip: "contractSettings.postAddress.locationZip",
      contractLocationCity: "contractSettings.postAddress.locationCity",
      contractLocationName: "contractSettings.postAddress.locationName",
      contractSelectedLocationName:
        "contractSettings.postAddress.selectedLocationName",
      contractLocationType: "contractSettings.postAddress.locationType",
      contractLocationHouseNumber:
        "contractSettings.postAddress.locationHouseNumber",
      contractLocationBuilding: "contractSettings.postAddress.locationBuilding",
      contractLocationTopography:
        "contractSettings.postAddress.locationTopography",

      contractedIsInsured: "insuredSettings.contractedIsInsured",
      insuredLastName: "insuredSettings.lastName",
      insuredFirstName: "insuredSettings.firstName",
      insuredMotherChildName: "insuredSettings.motherChildName",
      insuredBornName: "insuredSettings.bornName",
      insuredBornCity: "insuredSettings.bornCity",
      insuredBornDate: "insuredSettings.bornDate",
      insuredEmail: "insuredSettings.email",
      insuredPhoneNumberArea: "insuredSettings.phoneNumberArea",
      insuredPhoneNumber: "insuredSettings.phoneNumber",

      propertyIsMortgaged: "mortgageSettings.propertyIsMortgaged",
      mortgageCreditor: "mortgageSettings.creditor",
      mortgageCreditorLocation: "mortgageSettings.creditorLocation",
      mortgageId: "mortgageSettings.mortgageId",
      mortgagePrice: "mortgageSettings.mortgagePrice",
      mortgageCurrency: "mortgageSettings.mortgageCurrency",
      mortgageStartDate: "mortgageSettings.mortgageStartDate",
      mortgageEndDate: "mortgageSettings.mortgageEndDate",
      mortgageList: "chooseableAccesories.mortgage.list",
      ertekesito_koti: "ertekesito_koti",
      dm: "dm",
      contractReason: "kotes_oka",
    }),
    chosenAccessories: function() {
      let accesories = [];

      Object.entries(this.$store.state.chosenAccessories).forEach(
        (accesory) => {
          if (
            accesory[1]?.selected &&
            Object.keys(
              this.valaszthatoKiegeszitok[this.chosenPackage],
            ).includes(accesory[0])
          )
            accesories.push(accesory[0]);
        },
      );

      // console.log("chosenaccessories: ")
      // console.log(accesories)

      return accesories;
    },
    stringPropertyType: function() {
      switch (this.propertyType) {
        case "tarsashaz":
          return "Társasházi lakás";
        case "csaladihaz":
          return "Családi ház";
        case "sorhaz":
          return "Sorház";
        case "ikerhaz":
          return "Ikerház";
      }
    },
    stringPropertyOwnType: function() {
      switch (this.propertyOwnRight) {
        case "sajat":
          return "Saját tulajdon saját használatban";
        case "sajat_berbe":
          return "Saját tulajdon bérbe adva";
        case "berlemeny":
          return "Bérlemény";
      }
    },
    stringPaymentType: function() {
      switch (this.paymentOptionsType) {
        case "csoportos":
          return "Csoportos beszedési megbízás";
        case "online":
          return "Online bankkártyás fizetés";
        case "atutalas":
          return "Átutalás";
        case "csekk":
          return "Postai csekk";
      }
    },
    stringPaymentFrequency: function() {
      switch (this.paymentOptionsFrequency) {
        case "eves":
          return "Éves";
        case "feleves":
          return "Féléves";
        case "negyedeves":
          return "Negyedéves";
        case "havi":
          return "Havi";
      }
    },
    paymentFrequentString() {
      const frequency = this.$store.state.paymentOptions.frequency;
      let stringFrequency;
      if (frequency == "eves") stringFrequency = " /év";
      else if (frequency == "feleves") stringFrequency = " /félév";
      else if (frequency == "negyedeves") stringFrequency = " /negyedév";
      else stringFrequency = " /hó";
      return (
        this.$options.filters.currency(
          this.$store.state.gyakorisag_szerint_fizetendo_dij,
        ) + stringFrequency
      );
    },
  },
  methods: {
    insuranceTermsClick(e) {
      if (e) e.preventDefault();
      this.insuranceTermsOpened = !this.insuranceTermsOpened;
    },
    rbnbTermsClick(e) {
      if (e) e.preventDefault();
      this.rbnbTermsOpened = !this.rbnbTermsOpened;
    },
    insuranceBondStatementClick(e) {
      if (e) e.preventDefault();
      this.insuranceBondStatementOpened = !this.insuranceBondStatementOpened;
    },
    contractPracticeStatementClick(e) {
      if (e) e.preventDefault();
      this.contractPracticeStatementOpened = !this
        .contractPracticeStatementOpened;
    },
    stringPropertyWall: function(str) {
      switch (str) {
        case "tegla":
          return "Tégla";
        case "beton":
          return "Beton";
        case "ko":
          return "Kő";
        case "panel":
          return "Panel";
        case "konnyuszerk":
          return "Könnyűszerkezetes";
        case "fa":
          return "Fa";
        case "valyog":
          return "Vályog";
        case "vegyes":
          return "Vegyes (vályog és szilárd)";
      }
    },
    stringPropertyRoof: function(str) {
      switch (str) {
        case "cserep":
          return "Cserép";
        case "pala":
          return "Pala";
        case "nad":
          return "Nád";
        case "fazsindely":
          return "Fazsindely";
        case "szalma":
          return "Szalma";
        case "bitumen":
          return "Bitumenes";
        case "muanyag":
          return "Műanyag";
        case "fem":
          return "Fém";
        case "hullamlemez":
          return "Bitumenes hullámlemez";
      }
    },
  },
  watch: {
    emailVerifyToken: function(value) {
      if (btoa(value) == this.$store.state.email_valid_code)
        this.emailVerified = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$red: #e4002b;

ul.hyphens {
  list-style-type: none;
}

ul.hyphens > li:before {
  content: "–";
  position: absolute;
  margin-left: -1.1em;
}

/*
.arrow-up {
  width: 0;
  height: 0;
  background: none;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 4px solid transparent;
  border-bottom: 10px solid $red;
  margin-left: 5px;
  display: inline-block;
  cursor: pointer;
}

.arrow-down {
  width: 0;
  height: 0;
  background: none;
  border-bottom: 4px solid transparent;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-top: 10px solid $red;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
*/

.arrow-down {
  background-color: transparent;
  border: none;
}
.arrow-up {
  background-color: transparent;
  border: none;
}

.form-check-label {
  margin-top: -20px;
  margin-left: 5px;
}

iframe.docs-container #document html body:focus-within {
  /* inner indicator */
  outline: 2px #fff solid !important;
  outline-offset: 0 !important;
  /* outer indicator */
  box-shadow: 0 0 0 4px #000 !important;
}
</style>
